import RetailerInfo from './components/RetailerInfo';
import withRouter from 'react-router-dom/withRouter';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';

import {
  loadRetailer,
  updateRetailer,
  createRetailer
} from '../../shared/redux/entities/actions'

function mapStateToProps(state,props){
  const retailerId = props.retailerId,
    isCreate = props.match.url.indexOf('new') >= 0;

  return {
    isCreate:isCreate,
    retailerId:retailerId,
    name:get(state,['entities','companies',retailerId,'name']),
    logoURL:get(state,['entities','companies',retailerId,'logoURL']),
    logoFileName:get(state,['entities','companies',retailerId,'logoFileName']),
    primaryColor:get(state,['entities','companies',retailerId,'primaryColor'])
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadRetailer,
    updateRetailer,
    createRetailer
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(RetailerInfo));



// WEBPACK FOOTER //
// ./src/routes/RetailerInfo/index.js